<template>
  <div class="level">
    <LevelRow
      @toggle="toggleIFrame"
      :hasAccess="hasAccess"
      :contentType="content.type"
      :contentId="content.id"
      :status="contentStatus"
      :statusText="statusText"
      :parentStatus="courseStatus"
      :title="title"
      :plansLink="plansLink"
      :isWatching="isWatching"
      :details="iFrameDetails"
      :progress="progress"
      @click.native="toggleIFrame"
    >
    </LevelRow>
    <div class="level__content" v-if="isWatching">
      <MediaDelegate
        v-bind="{
          parentType: 'course',
          content: content,
          userCompletionStatus: contentStatus,
        }"
        @is-loading="setLoader"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CONSTANTS from '@/constants'
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import LevelRow from '@/components/content/level/LevelRow.vue'

export default {
  name: 'IFrameLevelNew',
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    MediaDelegate,
    LevelRow,
  },
  props: {
    courseId: {
      type: String,
      required: true,
    },
    courseStatus: {
      type: String,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    contentStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      playingIFrameId: state => state.iframes.playingIFrameId,
    }),
    isWatching() {
      return this.content.id === this.playingIFrameId
    },
    iFrameDetails() {
      const slides = this.content.metadata?.slides_count
        ? this.content.metadata.slides_count
        : 0
      if (slides === 0) return []
      return slides === 1 ? [`${slides} slide`] : [`${slides} slides`]
    },
    progress() {
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.STARTED) {
        return 50
      }
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return 100
      }
      return 0
    },
    statusText() {
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.STARTED) {
        return `Resume slides`
      }
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return `Restart slides`
      }
      return `Start slides`
    },
  },
  methods: {
    async toggleIFrame() {
      if (this.hasAccess && !this.isLoading) {
        if (this.playingIFrameId === this.content.id) {
          this.$store.dispatch('iframes/setPlayingIFrameId', '')
        } else {
          this.$store.dispatch('iframes/setPlayingIFrameId', this.content.id)
        }
        this.$emit('toggle-content', CONSTANTS.CONTENT_TYPES.IFRAME)
      }
    },
    isContentSelected() {
      if (this.isLoading) {
        return 'level__trigger level__trigger--disabled'
      }
      if (this.isWatching) {
        return 'level__trigger level__trigger--selected'
      }
      return 'level__trigger'
    },
    setLoader(state) {
      this.isLoading = state
    },
  },
}
</script>
